/* * * ./app/error.component.ts * * */
// Imports
import { Component } from '@angular/core';

// Component decorator
@Component({
    template: require('./error.component.html')
})
// Ticket class
export class ErrorComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/error.component.ts